// NRN: rewards/upsell progress bar updater.
// IMPORTANT: this used to live as an inline <script> inside
// snippets/cart-progress-bar.liquid. That worked on a hard page load, but
// browsers never execute <script> tags that arrive via `.innerHTML = ...`
// (which is exactly how every AJAX cart update injects fresh markup here).
// Result: after add-to-cart or a quantity change, the bar's own update logic
// silently never ran again. Living in this real, externally-loaded file
// guarantees it always executes, and callers below invoke it explicitly
// right after each DOM swap.
function nrnUpdateRewardsBar(itemCount) {
  if (typeof itemCount !== 'number') return;
  const bar = document.getElementById('cd-progress-bar');
  const i1 = document.getElementById('cd-icon-1');
  const i2 = document.getElementById('cd-icon-2');
  const msg = document.getElementById('cd-rewards-msg');
  if (!bar || !i1) return;

  let pct = 0;
  if (itemCount >= 3) pct = 100;
  else if (itemCount >= 2) pct = 50;
  bar.style.width = pct + '%';

  i1.classList.toggle('op_active', itemCount >= 2);
  if (i2) i2.classList.toggle('op_active', itemCount >= 3);

  if (msg) {
    if (itemCount < 2) {
      msg.innerHTML = 'Add ' + (2 - itemCount) + ' additional item for a <strong>15% Discount</strong>';
    } else if (itemCount < 3) {
      msg.innerHTML = 'Add 1 additional item for a <strong>20% Discount</strong>';
    } else {
      msg.innerHTML = '🎉 You unlocked <strong>20% OFF</strong>!';
    }
  }
}
window.nrnUpdateRewardsBar = nrnUpdateRewardsBar;

// NRN: Dieser Zusatz-Request ist entfallen.
// --------------------------------------------------------------------------
// Hier lief bei JEDEM cart:updated und cart:refresh ein eigenes fetch('/cart.js'),
// nur um die Artikelzahl fuer den Rabattbalken zu erfahren. Die Zahl steht aber
// bereits in der Antwort, die renderContents() ohnehin verarbeitet
// (parsedState.item_count) — und dort wird nrnUpdateRewardsBar() seit jeher
// direkt aufgerufen. Der Request war also reine Doppelarbeit und hat nach jedem
// Klick eine weitere Anfrage auf die Leitung gelegt, die mit dem eigentlichen
// Add-to-cart um Bandbreite konkurrierte.
//
// Fuer den Fall, dass ein Fremd-Programm den Warenkorb auf einem Weg aendert,
// der renderContents() nie beruehrt, wird die Zahl weiterhin nachgezogen — aber
// aus dem Ereignis selbst, ohne zusaetzliche Anfrage. Nur wenn dort gar nichts
// mitgeliefert wird, faellt es auf eine einzelne Abfrage zurueck.
function nrnSyncRewardsBarFromEvent(event) {
  var detail = event && event.detail;
  var count =
    (detail && typeof detail.item_count === 'number' && detail.item_count) ||
    (detail && detail.cartData && detail.cartData.item_count);

  if (typeof count === 'number') {
    nrnUpdateRewardsBar(count);
    return;
  }

  // Letzter Ausweg, hoechstens einmal pro Sekunde.
  var now = Date.now();
  if (nrnSyncRewardsBarFromEvent._last && now - nrnSyncRewardsBarFromEvent._last < 1000) return;
  nrnSyncRewardsBarFromEvent._last = now;

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (c) { nrnUpdateRewardsBar(c.item_count); })
    .catch(function () {});
}
document.addEventListener('cart:updated', nrnSyncRewardsBarFromEvent);
document.addEventListener('cart:refresh', nrnSyncRewardsBarFromEvent);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this._ensureNrnBackdropV27();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    const overlay = this.querySelector("#CartDrawer-Overlay");
    if (overlay) {
      ["click", "mousedown", "touchstart"].forEach((eventName) => {
        overlay.addEventListener(eventName, (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.close();
        }, { passive: false });
      });
    }

    // v30: Do NOT use document-level click blockers.
    // They can catch the same pointerup/click that opened the drawer and instantly close it.
    // The body backdrop below handles outside-click safely without reaching page buttons.

    this._nrnPreventBackgroundScrollV28 = (event) => {
      if (!this.classList.contains('active')) return;
      // v39: only the cart-drawer-items scroll box may scroll. Touchmoves on
      // the footer/header/rewards bar (or the page behind) chain-scroll the
      // body on iOS — block them all. The boundary handler below takes care
      // of rubber-banding at the top/bottom edge of the items list.
      const items = this.querySelector('cart-drawer-items');
      if (items && items.contains(event.target)) return;
      // v43: the "Others Also Bought" carousel lives in the drawer FOOTER, so
      // the blanket preventDefault above killed every horizontal swipe there —
      // only the arrow buttons worked. Its viewport is a real scroll container
      // (touch-action: pan-x), so let its touch stream through untouched.
      const t = event.target;
      if (t && t.closest && t.closest('[data-nrn-cu-viewport]')) return;
      event.preventDefault();
    };
    // NRN: Diese Listener haengen NICHT mehr dauerhaft am document.
    // ------------------------------------------------------------------
    // wheel und touchmove lagen hier mit passive:false global am Dokument —
    // also auch dann, wenn der Drawer gar nicht offen war. Ein nicht-passiver
    // touchmove-Listener zwingt den Browser, bei JEDER Wischbewegung auf der
    // gesamten Seite erst den JavaScript-Handler abzuwarten, bevor er
    // scrollen darf. Die Scroll-Optimierung des Browsers ist damit fuer die
    // komplette Seite abgeschaltet, und das Scrollen fuehlt sich zaeh an.
    //
    // Gebunden wird jetzt in open(), geloest in close(). Siehe
    // _nrnBindScrollGuards() weiter unten.

    // v36 FIX: Block touchmove when cart-drawer-items hits its scroll boundary.
    // This prevents iOS rubber-band bounce from pulling content below the drawer.
    this._nrnBlockBoundaryScroll = (event) => {
      if (!this.classList.contains('active')) return;
      const items = this.querySelector('cart-drawer-items');
      if (!items || !items.contains(event.target)) return;
      // NRN: highest priority — the "Others Also Bought" carousel must NEVER
      // get stuck, no matter where inside it the swipe starts, including
      // right at the items-list scroll boundary. Without this exemption a
      // touch that begins while cart-drawer-items is already scrolled to the
      // bottom gets its horizontal carousel swipe eaten by the vertical
      // boundary-lock below.
      const swipeTarget = event.target;
      if (swipeTarget && swipeTarget.closest && swipeTarget.closest('[data-nrn-cu-viewport]')) return;
      // Allow scrolling only when not at the boundary
      const touch = event.touches[0];
      if (!touch) return;
      const deltaY = touch.clientY - (this._nrnLastTouchY || touch.clientY);
      this._nrnLastTouchY = touch.clientY;
      const atTop = items.scrollTop <= 0;
      const atBottom = items.scrollTop + items.clientHeight >= items.scrollHeight - 1;
      if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
        event.preventDefault();
      }
    };
    this._nrnTrackTouchStart = (event) => {
      if (!this.classList.contains('active')) return;
      const touch = event.touches[0];
      if (touch) this._nrnLastTouchY = touch.clientY;
    };
    // Ebenfalls erst beim Oeffnen binden — siehe Begruendung oben.

    this.setHeaderCartIconAccessibility();
  }


  /**
   * NRN: Scroll-Sperren aktivieren. Wird ausschliesslich von open() gerufen.
   * Solange der Drawer zu ist, haengt kein einziger nicht-passiver
   * Scroll-Listener am Dokument — die Seite scrollt dann mit voller
   * Browser-Optimierung.
   */
  _nrnBindScrollGuards() {
    if (this._nrnGuardsBound) return;
    this._nrnGuardsBound = true;

    document.addEventListener('wheel', this._nrnPreventBackgroundScrollV28, { capture: true, passive: false });
    document.addEventListener('touchmove', this._nrnPreventBackgroundScrollV28, { capture: true, passive: false });
    document.addEventListener('touchstart', this._nrnTrackTouchStart, { capture: true, passive: true });
    document.addEventListener('touchmove', this._nrnBlockBoundaryScroll, { capture: true, passive: false });
  }

  /** NRN: Gegenstueck zu _nrnBindScrollGuards(), gerufen von close(). */
  _nrnUnbindScrollGuards() {
    if (!this._nrnGuardsBound) return;
    this._nrnGuardsBound = false;

    document.removeEventListener('wheel', this._nrnPreventBackgroundScrollV28, { capture: true });
    document.removeEventListener('touchmove', this._nrnPreventBackgroundScrollV28, { capture: true });
    document.removeEventListener('touchstart', this._nrnTrackTouchStart, { capture: true });
    document.removeEventListener('touchmove', this._nrnBlockBoundaryScroll, { capture: true });
  }

  _ensureNrnBackdropV27() {
    let backdrop = document.querySelector('.nrn-cart-backdrop-v27');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'nrn-cart-backdrop-v27';
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.appendChild(backdrop);
    }
    if (!this._nrnBackdropBound) {
      const closeFromBackdrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      };
      ['click', 'mousedown', 'touchstart'].forEach((eventName) => {
        backdrop.addEventListener(eventName, closeFromBackdrop, { passive: false });
      });
      // Stop wheel/touch scrolling on the page behind the drawer.
      ['wheel', 'touchmove'].forEach((eventName) => {
        backdrop.addEventListener(eventName, (event) => {
          event.preventDefault();
        }, { passive: false });
      });
      this._nrnBackdropBound = true;
    }
    return backdrop;
  }

  _lockNrnPageScrollV27() {
    this._ensureNrnBackdropV27();

    // v28: freeze the page in place without transforming it.
    // This prevents the website/background from being pulled or distorted while the drawer slides.
    if (!document.body.classList.contains('nrn-cart-scroll-lock-v27')) {
      const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      document.body.dataset.nrnCartScrollY = String(scrollY);
      document.body.style.setProperty('--nrn-cart-scroll-y', `-${scrollY}px`);
      if (scrollbarWidth > 0) {
        document.body.style.setProperty('--nrn-cart-scrollbar-comp', `${scrollbarWidth}px`);
      } else {
        document.body.style.setProperty('--nrn-cart-scrollbar-comp', '0px');
      }
    }

    document.documentElement.classList.add('nrn-cart-scroll-lock-v27');
    document.body.classList.add('nrn-cart-scroll-lock-v27', 'nrn-cart-open-v27');
  }

  _unlockNrnPageScrollV27() {
    document.body.classList.remove('nrn-cart-open-v27');
    window.clearTimeout(this._nrnUnlockTimer);
    this._nrnUnlockTimer = window.setTimeout(() => {
      if (!this.classList.contains('active')) {
        const scrollY = parseInt(document.body.dataset.nrnCartScrollY || '0', 10) || 0;
        document.documentElement.classList.remove('nrn-cart-scroll-lock-v27');
        document.body.classList.remove('nrn-cart-scroll-lock-v27');
        document.body.style.removeProperty('--nrn-cart-scroll-y');
        document.body.style.removeProperty('--nrn-cart-scrollbar-comp');
        delete document.body.dataset.nrnCartScrollY;
        window.scrollTo(0, scrollY);
      }
    }, 240);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    this._nrnOpenedAt = Date.now();
    this._nrnBindScrollGuards();
    // v35i: Race-proof ATC open. If the customer closes the drawer quickly and
    // immediately adds another product, any old close/unlock timers must not
    // keep the next open stuck in is-closing / unlocked state.
    window.clearTimeout(this._nrnUnlockTimer);
    window.clearTimeout(this._nrnLockFallback);
    window.clearTimeout(this._nrnClosingCleanupTimer);
    this.classList.remove("is-closing");
    document.body.classList.add('nrn-cart-open-v27');
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // v39 ROOT-CAUSE FIX: lock the page scroll BEFORE the slide-in starts.
    // The old code locked on transitionend (or a 260ms fallback) — during
    // that window the page behind was still scrollable, which is exactly the
    // "man kann unten rausscrollen / drawer öffnet verbuggt" bug on mobile.
    // body gets position:fixed + top:-scrollY (no visual jump), and the
    // forced reflow below happens in the same frame BEFORE .active is added,
    // so the slide animation itself stays perfectly smooth.
    this.classList.remove("nrn-cart-loading", "is-closing", "active");
    this.classList.add("animate");
    this._lockNrnPageScrollV27();
    void this.offsetWidth;
    this.classList.add("active");
    // NRN: footer benefits line is now visible at its real width — fit it.
    try { this._nrnFitFooterBenefits(); } catch (_) {}
    const cartDrawerItems = this.querySelector("cart-drawer-items");
    if (cartDrawerItems) {
      cartDrawerItems.updateCartUpsellToggleState();
      const isEmpty = this.classList.contains("is-empty");
      const itemCountEl = this.querySelector("[data-cart-item-count]");
      const itemCount = isEmpty
        ? 0
        : (itemCountEl ? parseInt(itemCountEl.dataset.cartItemCount, 10) || 1 : 1);
      cartDrawerItems.updateCartUpsellVisibility(itemCount);
    }
    document.dispatchEvent(new CustomEvent('cart:open'));

    try { this._warmCheckout(); } catch (_) {}

    this.addEventListener(
      "transitionend",
      () => {
        // v39: scroll lock is already applied in open() — re-assert it only
        // as a safety net, then trap focus once the slide-in has finished.
        this._lockNrnPageScrollV27();

        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    // Safety net: if transitionend doesn't fire (browser bug, prefers-reduced-motion,
    // etc.), still re-assert the lock after a max delay.
    window.clearTimeout(this._nrnLockFallback);
    this._nrnLockFallback = window.setTimeout(() => this._lockNrnPageScrollV27(), 220);

    // body scroll-lock is handled by CSS: body:has(.drawer.active){overflow:hidden}
    // No JS body class needed — avoids double reflow triggering
  }

  _warmCheckout() {
    // Only warm if cart is not empty — Shopify rejects /checkout from empty carts
    if (this.classList.contains('is-empty')) return;
    if (this._checkoutWarmed) return;
    this._checkoutWarmed = true;

    // 1) Speculation Rules (Chrome / Edge) — actual prerender
    if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      try {
        const sr = document.createElement('script');
        sr.type = 'speculationrules';
        sr.textContent = JSON.stringify({
          prerender: [{ source: 'list', urls: ['/checkout'], eagerness: 'moderate' }]
        });
        document.head.appendChild(sr);
      } catch (_) {}
    }

    // 2) Plain prefetch fallback (Firefox + older Chrome)
    if (!document.querySelector('link[data-nrn-checkout-prefetch]')) {
      const l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = '/checkout';
      l.as = 'document';
      l.setAttribute('data-nrn-checkout-prefetch', '');
      document.head.appendChild(l);
    }
  }

  close() {
    if (!this.classList.contains("active") && !this.classList.contains("is-closing")) return;
    this._nrnUnbindScrollGuards();
    window.clearTimeout(this._nrnLockFallback);
    this.classList.remove("nrn-cart-loading");
    this.classList.add("is-closing");
    this.classList.remove("active");
    this._unlockNrnPageScrollV27();
    document.dispatchEvent(new CustomEvent('cart:close'));
    removeTrapFocus(this.activeElement);
    window.clearTimeout(this._nrnClosingCleanupTimer);
    this._nrnClosingCleanupTimer = window.setTimeout(() => {
      if (!this.classList.contains("active")) this.classList.remove("is-closing");
    }, 200);
    // body:has(.drawer.active) CSS auto-releases when active class is removed above
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    // Strip empty-state classes before injecting content so open() never
    // reads is-empty and shows the wrong state.
    this.classList.remove('is-empty');
    this.classList.remove('nrn-cart-loading');
    const drawerInner = this.querySelector(".drawer__inner");
    if (drawerInner) drawerInner.classList.remove("is-empty");
    this.productId = parsedState.id;

    // PERF: Parse new HTML and preload ALL product images BEFORE the DOM swap.
    // Each image gets its own <link rel="preload"> — browser fetches in parallel.
    try {
      const tempDoc = new DOMParser().parseFromString(
        parsedState.sections['cart-drawer'] || '',
        'text/html'
      );
      // Remove stale preload links from previous renders
      document.querySelectorAll('link[data-nrn-img-preload]').forEach(l => l.remove());
      tempDoc.querySelectorAll('.cart-item__image[src]').forEach((img) => {
        const src = img.getAttribute('src');
        if (!src) return;
        if (document.querySelector(`link[data-nrn-img-preload="${CSS.escape(src)}"]`)) return;
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = src;
        link.fetchPriority = 'high';
        link.setAttribute('data-nrn-img-preload', src);
        document.head.appendChild(link);
        setTimeout(() => link.remove(), 12000);
      });
    } catch (_) {}

    // Update all sections (DOM swap is synchronous, sub-millisecond)
    // NRN FIX (drawer sometimes not opening): one missing/broken section in the
    // /cart/add response used to throw here, the exception bubbled into the
    // fetch .catch() in product-form.js and the open() call at the bottom of
    // renderContents never ran — item added, drawer closed. Each section swap
    // is now isolated, so a single bad section can never block the drawer.
    const nrnSections = (parsedState && parsedState.sections) || {};
    this.getSectionsToRender().forEach((section) => {
      try {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;
        if (typeof nrnSections[section.id] !== 'string') return;
        sectionElement.innerHTML = this.getSectionInnerHTML(
          nrnSections[section.id],
          section.selector
        );
      } catch (e) {
        console.error('NRN cart-drawer: section swap failed for', section.id, e);
      }
    });

    // NRN: sync the rewards/upsell bar to the just-added state. Needed because
    // the bar's markup was just replaced above and any <script> inside that
    // fresh HTML will NOT execute (browsers ignore scripts injected via
    // .innerHTML) — this explicit call is what actually keeps it correct.
    try { nrnUpdateRewardsBar(parsedState.item_count); } catch (_) {}

    // NRN: fire the upsell fetch NOW — right after the fresh DOM landed —
    // instead of waiting for the drawer's open animation/cart:open event.
    // By the time the slide-in finishes, the widget is already populated.
    try { if (window.nrnLoadUpsell) window.nrnLoadUpsell(); } catch (_) {}

    // PERF: Force eager decode on all cart images after DOM swap.
    // If image was prefetched on pointerdown it's already in cache = instant paint.
    this.querySelectorAll('.cart-item__image').forEach((img) => {
      img.loading = 'eager';
      img.fetchPriority = 'high';
      img.decoding = 'async';
      if (img.decode) img.decode().catch(() => {});
    });

    // NRN: fit the "Free Shipping & 30-Day Money-Back Guarantee" line to the
    // largest font-size that stays on ONE line (no wrap, no squish).
    try { this._nrnFitFooterBenefits(); } catch (_) {}

    // Re-bind overlay close (use replaceWith to avoid duplicate listeners)
    const overlay = this.querySelector("#CartDrawer-Overlay");
    if (overlay) {
      const newOverlay = overlay.cloneNode(true);
      overlay.parentNode.replaceChild(newOverlay, overlay);
      ["click", "mousedown", "touchstart"].forEach((eventName) => {
        newOverlay.addEventListener(eventName, (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.close();
        }, { passive: false });
      });
    }

    // v31 FIX: Always open after add-to-cart when the drawer is not active.
    // v35i: Always reopen after ATC, even if a fast manual close left the
    // drawer mid-close. This fixes the random "product added but drawer did
    // not open" state for both sticky and normal product forms.
    // v36 FIX: _nrnAtcRender flag set by product-form.js before renderContents
    // guarantees the drawer always opens on ATC regardless of active/is-closing
    // state. Quantity updates from inside the open drawer do NOT set this flag,
    // so they remain content-only swaps without re-animating the drawer.
    // NRN: KEIN ZWEITES EINFAHREN, WENN DER DRAWER SCHON OFFEN IST.
    // ==================================================================
    // Bis hierher galt: nach einem Add-to-cart IMMER neu aufziehen
    // (isAtcOpen). Das war richtig, solange der Drawer erst an dieser Stelle
    // ueberhaupt geoeffnet wurde.
    //
    // Seit assets/nrn-cart-engine.js ihn bereits beim Klick aufzieht, ist er
    // hier in aller Regel laengst offen und der Kunde schaut hinein. Das alte
    // Vorgehen (active entfernen -> Reflow erzwingen -> active wieder setzen)
    // haette die Einfahr-Animation mitten im Betrachten ein zweites Mal
    // gestartet: der Drawer waere sichtbar nach rechts gesprungen und erneut
    // hereingefahren.
    //
    // Deshalb jetzt drei Faelle:
    //   1. Drawer ist offen und faehrt nicht gerade zu -> nur Inhalt tauschen.
    //   2. Drawer ist zu (Engine konnte ihn nicht oeffnen, z.B. weil das
    //      Skript nicht geladen hat) -> normal aufziehen.
    //   3. Drawer faehrt gerade zu (schnelles Schliessen + sofort erneut
    //      hinzufuegen) -> Schliessvorgang abbrechen und neu aufziehen.
    const isAtcOpen = !!this._nrnAtcRender;
    this._nrnAtcRender = false;

    const istOffen = this.classList.contains("active");
    const faehrtZu = this.classList.contains("is-closing");

    if (istOffen && !faehrtZu) {
      // Fall 1 — der haeufigste. Inhalt ist getauscht, sonst nichts tun.
      this.classList.remove("nrn-cart-loading");
      try { this._warmCheckout(); } catch (_) {}
    } else if (isAtcOpen || !istOffen || faehrtZu) {
      // Fall 2 und 3
      this.classList.remove("active", "is-closing", "nrn-cart-loading");
      this.classList.add("animate");
      void this.offsetWidth;
      this.open();
    }

    // NRN: Meldet assets/nrn-cart-engine.js, dass der echte Inhalt steht —
    // damit raeumt sie ihren optimistischen Zustand ab.
    try {
      document.dispatchEvent(
        new CustomEvent('nrn:cart-rendered', { detail: { item_count: parsedState.item_count } })
      );
    } catch (_) {}
  }

  // NRN: maximize the footer benefits line font-size without wrapping.
  // Grows from a min up to a max and picks the largest size whose text still
  // fits the available width on a single line. white-space:nowrap guarantees
  // it never squishes; this guarantees it never wraps either.
  _nrnFitFooterBenefits() {
    return; // font-size set directly in CSS
    const el = this.querySelector('.cd-footer-benefits__text');
    if (!el) return;
    const container = el.parentElement || el;
    const run = () => {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const MIN = 11;
      const MAX = isMobile ? 24 : 26;
      // Available width = container content width (minus tiny safety margin)
      const avail = (container.clientWidth || el.clientWidth) - 2;
      if (avail <= 0) return;
      el.style.setProperty('white-space', 'nowrap', 'important');
      // Start at MAX, step DOWN 0.25px until it fits — always gets largest possible size.
      let best = MIN;
      el.style.setProperty('font-size', MAX + 'px', 'important');
      if (el.scrollWidth <= avail) {
        best = MAX;
      } else {
        for (let size = MAX; size >= MIN - 0.001; size -= 0.25) {
          el.style.setProperty('font-size', size + 'px', 'important');
          if (el.scrollWidth <= avail) { best = size; break; }
        }
      }
      el.style.setProperty('font-size', best + 'px', 'important');
    };
    // Run now and again next frame (fonts/layout may settle a tick later).
    run();
    requestAnimationFrame(run);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run).catch(() => {});
    }
    // Refit on resize (debounced), bound once.
    if (!this._nrnBenefitsResizeBound) {
      this._nrnBenefitsResizeBound = true;
      let t = null;
      window.addEventListener('resize', () => {
        clearTimeout(t);
        t = setTimeout(() => { try { this._nrnFitFooterBenefits(); } catch (_) {} }, 120);
      });
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
